export default __webpack_public_path__ + "static/media/2930 knife block A side.e81f4821.png";